import inArray from './inArray';

export default function uneditableField(field) {
    return this.form.meta && inArray(field, this.form.meta.uneditable_fields) && this.mode.edit;
}